export default __webpack_public_path__ + "static/media/web-mic-icon.386e7552.svg";